export default "__VITE_ASSET__oqX4_2CX__"